<template>
  <div>
    <!-- <div
      class="d-flex justify-content-end align-items-center overflow-x-auto list-btn-add"
    >
      <material-button class="btn btn-sm btn-background me-3">
        Import
      </material-button>
      <material-button
        class="btn btn-sm btn-background"
        @click="openAddItemModal"
      >
        <i class="material-icons css-icon">addoutlined</i>
        {{ isStockTransfer ? "Add" : "Add Item" }}
      </material-button>
    </div> -->
    <!-- <div class="d-flex justify-content-end align-items-center mt-3">
      <ShowHideColumn
        :columns="columns"
        :changeCheckbox="changeCheckbox"
        :columnCheckedCache="columnChecked"
        :isInventory="true"
        :key="key"
      />
    </div> -->
    <div class="row mt-3 justify-content-center">
      <div class="col-12 row px-1" :class="{ 'col-xxl-6 ': isStockTransfer }">
        <div class="col-12 px-1"  :class="isStockTransfer ? 'col-xxl-4' : 'col-xxl-3'">
          <div
            class="stock-level-box"
            :class="{
              active: type == (isStockTransfer ? STATUS_PENDING : GET_ALL),
            }"
            @click="changeType(isStockTransfer ? STATUS_PENDING : GET_ALL)"
          >
            <div class="title">All</div>
            <div class="value">{{ total }}</div>
          </div>
        </div>
        <div class="col-12 px-1" :class="isStockTransfer ? 'col-xxl-4' : 'col-xxl-3'">
          <div
            class="stock-level-box"
            :class="{
              active:
                type ==
                (isStockTransfer ? STATUS_IN_TRANSIT : GET_LOW_ON_STOCK),
            }"
            @click="
              changeType(isStockTransfer ? STATUS_IN_TRANSIT : GET_LOW_ON_STOCK)
            "
          >
            <div class="title">
              {{ isStockTransfer ? "In Transit" : "Low on Stock" }}
            </div>
            <div class="value" style="color: #dc3545">
              {{ total_low_on_stock }}
            </div>
          </div>
        </div>
        <div class="col-12 px-1"  :class="isStockTransfer ? 'col-xxl-4' : 'col-xxl-3'">
          <div
            class="stock-level-box"
            :class="{
              active:
                type ==
                (isStockTransfer ? STATUS_COMPLETED : GET_EXCEEDED_HIGH_STOCK),
            }"
            @click="
              changeType(
                isStockTransfer ? STATUS_COMPLETED : GET_EXCEEDED_HIGH_STOCK
              )
            "
          >
            <div class="title">
              {{ isStockTransfer ? "Completed" : "Exceeded High Stock" }}
            </div>
            <div
              class="value"
              :style="{ color: isStockTransfer ? '#198754' : '#133067' }"
            >
              {{ total_exceeded_high_stock }}
            </div>
          </div>
        </div>
        <div class="col-12 px-1" v-if="!isStockTransfer"  :class="isStockTransfer ? 'col-xxl-4' : 'col-xxl-3'">
          <div
            class="stock-level-box"
            :class="{
              active: type == GET_HIDDEN_ITEMS,
            }"
            @click="
              changeType(GET_HIDDEN_ITEMS)
            "
          >
            <div class="title">
              Hidden Items
            </div>
            <div class="value">
              {{ total_hidden_item }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 row px-1" :class="{ 'col-xxl-6 ': isStockTransfer }">
        <div class="row justify-content-end h-50" v-if="isStockTransfer">
          <div
            class="d-flex align-items-center col-lg-6 col-12"
            
          >
            <div class="me-3 text-bold">Period</div>
            <Multiselect
              v-model="timeType"
              :options="timeTypes"
              :canClear="false"
              placeholder="Select Time"
              @change="changeTimeType"
            />
          </div>
        </div>
        <div class="row" :class="isStockTransfer ? 'h-50' : 'mt-3'">
          <div
            class=" col-12 d-flex justify-content-around align-items-end px-1"
            :class="isStockTransfer ? 'col-xxl-8' : 'col-xxl-6'"
          >
            <div class="filter-more">
              <i class="material-icons me-1">add_circle_outline</i>
              <span>Type</span>
            </div>
            <div class="filter-more">
              <i class="material-icons me-1">add_circle_outline</i>
              <span>{{ isStockTransfer ? "Source" : "Group" }}</span>
            </div>
            <div class="filter-more">
              <i class="material-icons me-1">add_circle_outline</i>
              <span>{{ isStockTransfer ? "Dest" : "Supplier" }}</span>
            </div>
            <div class="filter-more">
              <i class="material-icons me-1">add_circle_outline</i>
              <span>Status</span>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-end align-items-end px-1" :class="isStockTransfer ? 'col-xxl-4' : 'col-xxl-6'">
            <button
              class="btn btn-sm btn-background me-1"
              style="margin-bottom: unset;"
              type="button"
              @click="resetFilters"
            >
              <span>Reset Filter</span>
            </button>
            <div class="d-flex align-items-end" v-if="columns && columns.length > 0 && changeCheckbox || !isStockTransfer">
              <ShowHideColumn
                :columns="columns"
                :changeCheckbox="changeCheckbox"
                :columnCheckedCache="columnChecked"
                :isInventory="true"
                :key="key"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-4 export-type">
      <button
        class="dt-button buttons-html5"
        type="button"
        @click="exportFile('csv')"
      >
        <span>Csv</span>
      </button>
      <button
        class="dt-button buttons-html5"
        type="button"
        @click="exportFile('xlsx')"
      >
        <span>Excel</span>
      </button>
      <button
        class="dt-button buttons-html5"
        type="button"
        @click="exportFile('pdf')"
      >
        <span>PDF</span>
      </button>
    </div>
  </div>
</template>

<script>
// import MaterialButton from "@/components/MaterialButton.vue";
import {
  GET_ALL,
  GET_LOW_ON_STOCK,
  GET_EXCEEDED_HIGH_STOCK,
  GET_HIDDEN_ITEMS,
  STATUS_PENDING,
  STATUS_COMPLETED,
  STATUS_IN_TRANSIT,
} from "../mock_data";
import ShowHideColumn from "@/components/ShowHideColumn.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import "@vueform/multiselect/themes/default.css";

export default {
  name: "FormSearch",
  components: {
    // MaterialButton,
    ShowHideColumn,
    Multiselect,
  },
  props: {
    openAddItemModal: {
      type: Function,
      default: () => {},
    },
    isStockTransfer: {
      type: Boolean,
      default: false,
    },
    getList: {
      type: Function,
      default: () => {},
    },
    total: {
      type: Number,
      default: 0,
    },
    total_low_on_stock: {
      type: Number,
      default: 0,
    },
    total_exceeded_high_stock: {
      type: Number,
      default: 0,
    },
    total_hidden_item: {
      type: Number,
      default: 0,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    columnChecked: {
      type: Array,
      default: () => [],
    },
    changeCheckbox: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      GET_ALL,
      GET_LOW_ON_STOCK,
      GET_EXCEEDED_HIGH_STOCK,
      GET_HIDDEN_ITEMS,
      STATUS_PENDING,
      STATUS_COMPLETED,
      STATUS_IN_TRANSIT,
      type: this.isStockTransfer ? STATUS_PENDING : GET_ALL,
      key: Math.random(),
      timeTypes: [
        { label: "All time", value: 0 },
        { label: "Today", value: 1 },
        { label: "Last 7 days", value: 2 },
        { label: "Last 30 days", value: 3 },
      ],
      timeType: 3,
    };
  },
  methods: {
    resetFilters() {
      this.timeType = 3;
      this.$emit("reset-filters");
    },

    exportFile(type) {
      this.$emit("export", type);
    },

    changeType(type) {
      this.type = type;
      this.getList(1, type, this.timeType);
    },

    changeTimeType(timeType) {
      this.timeType = timeType;
      this.getList(1, this.type, timeType);
    },
  },
};
</script>

<style scoped>
.stock-level-box {
  border: 1px solid #d5d6d8;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.stock-level-box.active {
  border: 2px solid #007bff;
}

.stock-level-box.active .title {
  color: #007bff !important;
}

.stock-level-box .value {
  font-size: 40px;
}

.filter-more {
  padding: 0 10px;
  border: 1px solid #d5d6d8;
  border-radius: 15px;
  cursor: pointer;
  min-width: 105px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
}

.filter-more > span {
  color: #007bff !important;
}

.css-icon {
  position: absolute;
  left: 17px !important;
  font-size: 18px !important;
  top: 7px !important;
}

.export-type {
  position: absolute;
}

div.dt-button-info {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  margin-top: -100px;
  margin-left: -200px;
  background-color: white;
  border: 2px solid #111;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  text-align: center;
  z-index: 21;
}
div.dt-button-info h2 {
  padding: 0.5em;
  margin: 0;
  font-weight: normal;
  border-bottom: 1px solid #ddd;
  background-color: #f3f3f3;
}
div.dt-button-info > div {
  padding: 1em;
}
div.dt-button-collection-title {
  text-align: center;
  padding: 0.3em 0 0.5em;
  font-size: 0.9em;
}
div.dt-button-collection-title:empty {
  display: none;
}
button.dt-button {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  margin-right: 0.333em;
  margin-bottom: 0.333em;
  padding: 0.5em 1em;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  cursor: pointer;
  font-size: 0.88em;
  line-height: 1.6em;
  color: black;
  white-space: nowrap;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.1);
  background: -webkit-linear-gradient(
    top,
    rgba(230, 230, 230, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -moz-linear-gradient(
    top,
    rgba(230, 230, 230, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(230, 230, 230, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(230, 230, 230, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(230, 230, 230, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='rgba(230, 230, 230, 0.1)', EndColorStr='rgba(0, 0, 0, 0.1)');
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-decoration: none;
  outline: none;
  text-overflow: ellipsis;
}
button.dt-button.disabled {
  cursor: default;
  opacity: 0.4;
}
button.dt-button:active:not(.disabled),
button.dt-button.active:not(.disabled) {
  background-color: rgba(0, 0, 0, 0.1);
  background: -webkit-linear-gradient(
    top,
    rgba(179, 179, 179, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -moz-linear-gradient(
    top,
    rgba(179, 179, 179, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(179, 179, 179, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(179, 179, 179, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(179, 179, 179, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='rgba(179, 179, 179, 0.1)', EndColorStr='rgba(0, 0, 0, 0.1)');
  box-shadow: inset 1px 1px 3px #999999;
}
button.dt-button:active:not(.disabled):hover:not(.disabled),
button.dt-button.active:not(.disabled):hover:not(.disabled) {
  box-shadow: inset 1px 1px 3px #999999;
  background-color: rgba(0, 0, 0, 0.1);
  background: -webkit-linear-gradient(
    top,
    rgba(128, 128, 128, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -moz-linear-gradient(
    top,
    rgba(128, 128, 128, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(128, 128, 128, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(128, 128, 128, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(128, 128, 128, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='rgba(128, 128, 128, 0.1)', EndColorStr='rgba(0, 0, 0, 0.1)');
}
button.dt-button:hover {
  text-decoration: none;
}
button.dt-button:hover:not(.disabled) {
  border: 1px solid #666;
  background-color: rgba(0, 0, 0, 0.1);
  background: -webkit-linear-gradient(
    top,
    rgba(153, 153, 153, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -moz-linear-gradient(
    top,
    rgba(153, 153, 153, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(153, 153, 153, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(153, 153, 153, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(153, 153, 153, 0.1) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='rgba(153, 153, 153, 0.1)', EndColorStr='rgba(0, 0, 0, 0.1)');
}
button.dt-button:focus:not(.disabled) {
  border: 1px solid #426c9e;
  text-shadow: 0 1px 0 #c4def1;
  outline: none;
  background-color: #79ace9;
  background: -webkit-linear-gradient(top, #d1e2f7 0%, #79ace9 100%);
  background: -moz-linear-gradient(top, #d1e2f7 0%, #79ace9 100%);
  background: -ms-linear-gradient(top, #d1e2f7 0%, #79ace9 100%);
  background: -o-linear-gradient(top, #d1e2f7 0%, #79ace9 100%);
  background: linear-gradient(to bottom, #d1e2f7 0%, #79ace9 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='#d1e2f7', EndColorStr='#79ace9');
}
div.dt-button-collection button.dt-button {
  position: relative;
  left: 0;
  right: 0;
  width: 100%;
  display: block;
  float: none;
  margin-bottom: 4px;
  margin-right: 0;
}
div.dt-button-collection button.dt-button:active:not(.disabled),
div.dt-button-collection button.dt-button.active:not(.disabled) {
  background-color: #dadada;
  background: -webkit-linear-gradient(top, #f0f0f0 0%, #dadada 100%);
  background: -moz-linear-gradient(top, #f0f0f0 0%, #dadada 100%);
  background: -ms-linear-gradient(top, #f0f0f0 0%, #dadada 100%);
  background: -o-linear-gradient(top, #f0f0f0 0%, #dadada 100%);
  background: linear-gradient(to bottom, #f0f0f0 0%, #dadada 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr='#f0f0f0', EndColorStr='#dadada');
  box-shadow: inset 1px 1px 3px #666;
}
button.dt-button.processing {
  color: rgba(0, 0, 0, 0.2);
}
button.dt-button.processing:after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  box-sizing: border-box;
  display: block;
  content: " ";
  border: 2px solid #282828;
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;
  animation: dtb-spinner 1500ms infinite linear;
  -o-animation: dtb-spinner 1500ms infinite linear;
  -ms-animation: dtb-spinner 1500ms infinite linear;
  -webkit-animation: dtb-spinner 1500ms infinite linear;
  -moz-animation: dtb-spinner 1500ms infinite linear;
}

@media (max-width: 1400px) {
  .col-xxl-4,
  .col-xxl-2 {
    margin-top: 16px;
  }
}

@media (max-width: 768px) {
  .col-xxl-6 > .col-md-4 {
    margin-bottom: 16px;
  }
}

@media (max-width: 500px) {
  .col-xxl-8 {
    padding-bottom: 10px;
    overflow-x: auto;
  }

  .filter-more {
    margin: 0 10px;
  }

  .list-btn-add {
    justify-content: start !important;
    padding-bottom: 10px;
  }

  .list-btn-add > button {
    min-width: 165px;
  }
}
</style>
